module.exports = __webpack_public_path__ + "img/VeryHappy_1.7dccd1da.png";